import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import _ from "lodash";

export function CustomSelect({
  id,
  menuItems,
  values,
  errors,
  onChange,
  gridValues,
}) {
  return (
    <Grid item xs={gridValues.xs} sm={gridValues.sm}>
      <FormControl required fullWidth>
        <InputLabel
          id={`${id}-input-label`}
          error={errors && errors.noOfSamplesRequired && true}
        >
          {_.startCase(id)}
        </InputLabel>
        <Select
          labelId={`${id}-select-label`}
          id={`${id}-simple-select`}
          label={_.startCase(id)}
          value={values[id]}
          name={id}
          onChange={onChange}
          error={errors && errors[id] && true}
          MenuProps={{ PaperProps: { sx: { maxHeight: "15%" } } }}
        >
          {menuItems.map((item, index) => (
            <MenuItem value={item} key={index}>
              {item}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText error={errors && errors[id] && true}>
          {errors && errors[id] !== "" ? errors[id] : ""}
        </FormHelperText>
      </FormControl>
    </Grid>
  );
}
